import type {GetCalendars_calendars as Calendar} from 'nutshell-graphql-types';

export function getDisabledDataTipText(
    calendar: Calendar,
    modalType: 'sync' | 'conflict'
): string | null | undefined {
    if (calendar.syncType === 'PRIMARY') {
        return 'This calendar cannot be added as <br /> an extra because it is synced.';
    }

    if (calendar.syncType === 'CONFLICT') {
        if (modalType === 'conflict') {
            return 'This calendar is already added as an extra calendar.';
        }

        return 'This calendar is already added. To <br /> sync this calendar, disconnect it as <br />an extra calendar.';
    }
}

export function getSelectedCalendarId(
    calendars: Calendar[],
    modalType: 'conflict' | 'sync'
): string | null | undefined {
    let selectedCalendar = null;

    if (modalType === 'sync') {
        selectedCalendar = calendars.find((calendar) => calendar.isSelected);
        if (selectedCalendar) {
            return selectedCalendar.id;
        }
    }

    selectedCalendar = calendars.find((calendar) => calendar.syncType === 'NONE');

    if (selectedCalendar) {
        return selectedCalendar.id;
    }

    return null;
}
